// extracted by mini-css-extract-plugin
export default {"pageSidebar":"Collapsable__pageSidebar___JK2cN","collapsed":"Collapsable__collapsed___RWUuS","expanded":"Collapsable__expanded___zxTdH"};